import { render } from "./CreateVolume.vue?vue&type=template&id=4c7df8c5&scoped=true"
import script from "./CreateVolume.vue?vue&type=script&lang=js"
export * from "./CreateVolume.vue?vue&type=script&lang=js"

import "./CreateVolume.vue?vue&type=style&index=0&id=4c7df8c5&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7df8c5"]])

export default __exports__